import { render, staticRenderFns } from "./FullScroll.vue?vue&type=template&id=f87d57cc&scoped=true&"
import script from "./FullScroll.vue?vue&type=script&lang=js&"
export * from "./FullScroll.vue?vue&type=script&lang=js&"
import style0 from "./FullScroll.vue?vue&type=style&index=0&id=f87d57cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87d57cc",
  null
  
)

export default component.exports